module.exports = __webpack_public_path__ + "img/LeadsAI.86980bf1.svg";